// Soft celebratory chimes via Web Audio — no asset download, quiet by design.
// Sound is always treated as a bonus stimulus: callers must skip it when the
// user has reduce-motion/sensory settings on (child shell) or the OS prefers
// reduced motion (adult screens).
import { pipGain } from "./pipVolume";

export const CHEER_NOTES = [[523.25, 0, 0.5], [659.25, 0.14, 0.5], [783.99, 0.28, 0.7]]; // C5-E5-G5
export const HEART_NOTES = [[659.25, 0, 0.3], [880, 0.12, 0.45]]; // E5-A5 "love sent" pop
export const THANK_YOU_NOTES = [[587.33, 0, 0.35], [739.99, 0.13, 0.35], [880, 0.26, 0.6]]; // D5-F#5-A5

// Quiet Hours Sounds: when the child shell registers its child, every chime
// and spoken line scales with pipGain — which auto-drops to a whisper in the
// hour before that child's quiet hours. Adult screens (no child set) stay 1.
let chimeChildId = null;
export const setChimeChild = (id) => { chimeChildId = id || null; };
const chimeGain = () => (chimeChildId ? pipGain(chimeChildId) : 1);

export const prefersReducedMotion = () =>
  window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;

// Child-area sound switch: when off, every chime silently no-ops.
let chimesEnabled = true;
export const setChimesEnabled = (on) => { chimesEnabled = on !== false; };

export const playChime = (notes) => {
  if (!chimesEnabled) return;
  const peak = 0.07 * chimeGain();
  if (peak <= 0.001) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    notes.forEach(([freq, start, dur]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(peak, ctx.currentTime + start + 0.04);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + dur + 0.05);
    });
    setTimeout(() => ctx.close().catch(() => {}), 2500);
  } catch {
    /* sound is a bonus, never a requirement */
  }
};
